import Link from 'next/link';

import { Typography } from 'lighthouse';

import { CategoryMegaMenuEmptyState } from '@/widgets/Navbar/DesktopMenu/_components/CategoryMegaMenu/_components/CategoryMegaMenuEmptyState';
import { CategoryMegaMenuMasonry } from '@/widgets/Navbar/DesktopMenu/_components/CategoryMegaMenu/_components/CategoryMegaMenuMasonry';

import { CAR_BATTERY_VEHICLE_TYPE_ID } from '@/constants/batteryProduct';

import { CategoryMegaMenuChildrenProps } from './models';

import { ArrowLeft2 } from 'iconsax-react';

export const CategoryMegaMenuChildren = ({ activeCategory, isDark, onNavigate }: CategoryMegaMenuChildrenProps) => {
    if (!activeCategory) {
        return null;
    }

    const hasSubCategories = activeCategory.subCategories.length > 0;

    return (
        <section className='flex h-full min-w-0 flex-1 flex-col overflow-hidden'>
            <div
                className={`flex shrink-0 items-center justify-between gap-4 border-b px-6 py-5 ${isDark ? 'border-neutral-700' : 'border-gray-200'}`}>
                <div className='min-w-0'>
                    <Typography variant='subtitle2' className={`truncate text-lg font-bold ${isDark ? 'text-white' : 'text-[#101828]'}`}>
                        {activeCategory.name}
                    </Typography>
                </div>
                {hasSubCategories && activeCategory.slug !== CAR_BATTERY_VEHICLE_TYPE_ID ? (
                    <Link
                        href={activeCategory.href}
                        onClick={onNavigate}
                        className={`inline-flex shrink-0 items-center gap-1.5 rounded-lg px-4 py-2 text-xs font-bold no-underline transition ${
                            isDark
                                ? 'bg-white/10 text-white hover:bg-white/15'
                                : 'bg-primary text-white hover:bg-primary/90 hover:shadow-[0_8px_20px_rgba(0,143,255,0.25)]'
                            }`}>
                        مشاهده همه
                        <ArrowLeft2 size={14} color='currentColor' />
                    </Link>
                ) : null}
            </div>

            <div className='nice-scroll min-h-0 flex-1 overflow-y-auto px-6 py-5'>
                {hasSubCategories ? (
                    <CategoryMegaMenuMasonry subCategories={activeCategory.subCategories} isDark={isDark} onNavigate={onNavigate} />
                ) : (
                    <CategoryMegaMenuEmptyState
                        categoryName={activeCategory.name}
                        categoryHref={activeCategory.href}
                        isDark={isDark}
                        onNavigate={onNavigate}
                    />
                )}
            </div>
        </section>
    );
};
